import { LineChart, Loader2 } from 'lucide-react';
import { AdminPageHeader, StatCard, useFetcher } from './_P1Common';

export default function AdminAdvancedAnalytics() {
  const { data, loading } = useFetcher('advanced-analytics');
  if (loading || !data) return <AdminPageHeader icon={LineChart} title="Napredna analitika"><Loader2 className="animate-spin"/></AdminPageHeader>;
  const maxDay = Math.max(1, ...data.recent_days.map(d => d.count));
  return (
    <div data-testid="admin-advanced-analytics">
      <AdminPageHeader icon={LineChart} title="Napredna analitika" subtitle="Pregled objavljenog sadržaja i angažmana"/>
      <div className="px-4 md:px-6 grid grid-cols-2 md:grid-cols-3 gap-3 mb-6">
        <StatCard testid="aa-total" label="Ukupno članaka" value={data.articles_total} accent="blue"/>
        <StatCard testid="aa-published" label="Objavljenih" value={data.published} accent="green"/>
        <StatCard testid="aa-top-views" label="Top pregled" value={data.top?.[0]?.views || 0} accent="violet"/>
      </div>
      <div className="px-4 md:px-6 pb-6 grid md:grid-cols-2 gap-6">
        <div className="border border-zinc-800 rounded-lg">
          <h3 className="px-4 py-2 border-b border-zinc-800 font-bold text-sm">Top 10 članaka po pregledima</h3>
          <ul className="divide-y divide-zinc-800">
            {(data.top || []).map(a => (
              <li key={a.id} className="px-4 py-2 flex items-center justify-between text-sm">
                <span className="truncate mr-2">{a.title}</span>
                <span className="text-red-400 font-bold">{a.views || 0}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="border border-zinc-800 rounded-lg">
          <h3 className="px-4 py-2 border-b border-zinc-800 font-bold text-sm">Po kategoriji</h3>
          <ul className="divide-y divide-zinc-800">
            {(data.per_category || []).slice(0, 10).map(c => (
              <li key={c.category} className="px-4 py-2 flex items-center justify-between text-sm">
                <span>{c.category || 'Ostalo'}</span>
                <span className="text-xs text-zinc-400">{c.count} · {c.views} pregleda</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="border border-zinc-800 rounded-lg md:col-span-2">
          <h3 className="px-4 py-2 border-b border-zinc-800 font-bold text-sm">Objave u zadnjih 14 dana</h3>
          <div className="p-4 flex items-end gap-1 h-40">
            {data.recent_days.map(d => (
              <div key={d.date} title={`${d.date}: ${d.count}`}
                   style={{ height: `${(d.count / maxDay) * 100}%` }}
                   className="flex-1 bg-red-700 rounded-t min-h-[4px]"/>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
